<template>
  <div class="page-style">
    <b-row>
      <b-col cols="3">
        <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
      </b-col>

      <b-col cols="6" class="pt-4"> </b-col>

      <b-col cols="3" class="pl-5">
        <b-row><field-label :label="'ID. Relatório'" :field="laudo.numero" /></b-row>
        <b-row><field-date-label :label="'Data'" :field="laudo.data" /></b-row>
      </b-col>
    </b-row>
    <hr />

    <div class="page-body">
      <b-row class="mt-2">
        <b-col cols="12" class="p-0">
          <div class="separador-div">
            <strong>INFORMAÇÕES GERAIS</strong>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-5 ml-5">
        <b-col cols="12" class="p-0 text-left">
          <h4><b-icon icon="align-start" /> <strong>DADOS DO EQUIPAMENTO</strong> <b-icon icon="align-end" /></h4>
        </b-col>
        <b-col cols="12" class="p-0 text-left">
          <h5><strong>Descrição: </strong>{{ equipamento.nome }}</h5>
          <h5><strong>Modelo: </strong>{{ laudo.modelo }}</h5>
          <h5><strong>Segurança: </strong>{{ laudo.seguranca }}</h5>
          <h5><strong>Código de Identificação SGCQ: </strong>{{ equipamento.sgcq }}</h5>
          <h5><strong>Local de Uso: </strong>{{ laudo.local }}</h5>
          <h5><strong>Dimensões: </strong>{{ equipamento.dimensoes }}</h5>
          <h5><strong>Peso do Equipamento: </strong>{{ equipamento.peso }}</h5>
          <h5><strong>Capacidade: </strong>{{ equipamento.carga }}</h5>
          <h5><strong>Detalhe: </strong>{{ laudo.detalhe }}</h5>
        </b-col>
      </b-row>

      <b-row class="mt-5 ml-5">
        <b-col cols="12" class="p-0 text-left">
          <h4><b-icon icon="align-start" /> <strong>RESPONSABILIDADE TÉCNICA</strong> <b-icon icon="align-end" /></h4>
        </b-col>
        <b-col cols="12" class="p-0 text-left">
          <h5><strong>Empresa Responsável: </strong>{{ laudo.empresa.nome }}</h5>
          <h5><strong>CNPJ: </strong>{{ laudo.empresa.cnpj }}</h5>
          <h5><strong>Endereço: </strong>{{ laudo.empresa.endereco }}</h5>
          <h5><strong>Bairro: </strong>{{ laudo.empresa.bairro }}</h5>
          <h5><strong>Cidade: </strong>{{ laudo.empresa.cidade }}</h5>
          <h5><strong>Engenheiro Responsável: </strong>{{ laudo.responsavel.nome }}</h5>
          <h5><strong>Registro no CREA: </strong>{{ laudo.registro }}</h5>
          <h5><strong>ART Vinculada: </strong>{{ laudo.art }}</h5>
        </b-col>
      </b-row>

      <b-row class="mt-5 ml-5">
        <b-col cols="12" class="p-0 text-left">
          <h4><b-icon icon="align-start" /> <strong>DADOS DO SOLICITANTE</strong> <b-icon icon="align-end" /></h4>
        </b-col>
        <b-col cols="12" class="p-0 text-left">
          <h5><strong>Empresa Solicitante: </strong>{{ laudo.solicitante.nome }}</h5>
          <h5><strong>CNPJ: </strong>{{ laudo.solicitante.cnpj }}</h5>
          <h5><strong>Endereço: </strong>{{ laudo.solicitante.endereco }}</h5>
          <h5><strong>Bairro: </strong>{{ laudo.solicitante.bairro }}</h5>
          <h5><strong>Cidade: </strong>{{ laudo.solicitante.cidade }}</h5>
          <h5><strong>Setor Solicitante: </strong>{{ laudo.setor }}</h5>
        </b-col>
      </b-row>

      <b-row class="mt-5 ml-5">
        <b-col cols="12" class="p-0 text-left">
          <h4><b-icon icon="align-start" /> <strong>DADOS DO CONTRATO</strong> <b-icon icon="align-end" /></h4>
        </b-col>
        <b-col cols="12" class="p-0 text-left">
          <h5><strong>Tipo de Serviço: </strong>{{ laudo.contrato.tipo }}</h5>
          <h5><strong>Início: </strong>{{ moment(laudo.contrato.inicio).format("DD/MM/YYYY") }}</h5>
          <h5><strong>Término: </strong>{{ moment(laudo.contrato.termino).format("DD/MM/YYYY") }}</h5>
          <h5><strong>Validade: </strong>{{ laudo.contrato.validade }}</h5>
        </b-col>
      </b-row>
    </div>

    <hr />
    <b-row>
      <h5 class="ml-4">{{ laudo.rodape }}</h5>
    </b-row>
  </div>
</template>

<script>
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import FieldAndLabel from "@/components/reports/parts/FieldAndLabel";
import FieldDateAndLabel from "@/components/reports/parts/FieldDateAndLabel";

export default {
  name: "FirstLaudoTecnicoReport",

  props: ["laudo", "equipamento"],

  components: {
    "field-label": FieldAndLabel,
    "field-date-label": FieldDateAndLabel,
  },

  data() {
    return {
      display: new LaudoTecnico(),
    };
  },

  methods: {},

  setup() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.page-style {
  width: 100%;
}

.page-body {
  height: 1300px;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #003c5a;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
